export { materialsListPersonalElements } from '@/app/services/vidu';
